import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function MapPin(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "MapPin", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.7692 44.2424C16.5006 44.2424 11 41.7272 11 38.4382c0-3.2891 5.5006-5.8042 12.7692-5.8042 7.2687 0 12.7693 2.5151 12.7693 5.8042 0 3.289-5.5006 5.8042-12.7693 5.8042Zm0-9.6737c-6.1881 0-10.8047 2.0315-10.8047 3.8695s4.6166 3.8694 10.8047 3.8694c6.1882 0 10.8048-2.0314 10.8048-3.8694s-4.6166-3.8695-10.8048-3.8695Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.7652 15.6747c0 6.4211-11.9953 22.3766-11.9953 22.3766S11.7745 22.0958 11.7745 15.6747C11.7745 9.25363 17.1724 4 23.7699 4c6.5974 0 11.9953 5.25363 11.9953 11.6747Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m26.3792 12.9634 4.7421.7854-3.4578 3.3382.6916 4.7126-4.2482-2.2581-4.2482 2.1599.7904-4.7126-3.4578-3.4363 4.8409-.5891 2.1735-4.31997 2.1735 4.31997Z",
        fill: theme.vars.palette.secondary.dark
      }
    )
  ] });
}
MapPin.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "MapPin"
};
validateTidalLicense();
export {
  MapPin
};
//# sourceMappingURL=MapPin.js.map
